/** Shared marketing copy for the ArtlessDev name and approach. */

export const BRAND_STORY_HEADLINE = "Why ArtlessDev?"

export const BRAND_STORY_SUMMARY =
  "Artless means plain and free of mystification. We also read it as less art: less reliance on gut feel and subjective narrative, more on evidence you can point to and objectivity everyone can check."

export const BRAND_STORY_PILLARS = [
  {
    title: "Less art, more evidence",
    body: "Every scenario is a behavioral fact backed by a concrete artifact — an HTTP response, a SQL row, a UI snippet — not gut feel or tribal knowledge passed around a team.",
  },
  {
    title: "Straightforward by design",
    body: "Scenarios are structured records, written in the app. No ticket theater, no ornate PRDs, no metaphors about specs being alive or dead — just the behavior, written down.",
  },
  {
    title: "Objectivity you can check",
    body: "QA records a fit when behavior matches the scenario, a gap when reality has moved away from it. The scenario's content stays the source of truth — status just records whether reality still lines up with it.",
  },
] as const
